export default __webpack_public_path__ + "static/B0318-606f538db5a53b9e80f39bd0ced1897e.png";